import { getFirestore,} from "firebase/firestore";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyBUZL3_fHzjaAlKjEnrSIqVpdSN-HYRkyg",
    authDomain: "atlo--chatting-page.firebaseapp.com",
    projectId: "atlo--chatting-page",
    storageBucket: "atlo--chatting-page.firebasestorage.app",
    messagingSenderId: "119269813475",
    appId: "1:119269813475:web:89cdf3e71b5ec27db069d6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
